<!-- 
列表页标题组件： 
分为：title desc
-->
<template>
  <div class="list-page-title-component app-flex-column">
    <h2 class="font-36 title">{{ title }}</h2>
    <p class="font-18">{{ desc }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.list-page-title-component {
  padding-top: 48px;
  align-items: center;
  .title {
    padding-bottom: 14px;
  }
}
</style>
